/**
 * Full page reload. A separate module so tests can mock it — jsdom's
 * `window.location.reload` is not reliably spy-able.
 */
export function reloadPage(): void {
  window.location.reload();
}

/** Full page navigation (not a client-side route change). */
export function assignPage(url: string): void {
  window.location.assign(url);
}
